module.exports = "<ul class=\"tabs__tab-bar\">\n  <li *ngFor=\"let tab of tabs\" (click)=\"selectTab(tab)\" class=\"tabs__tab\" [ngClass]=\"{'active': tab.active == true}\">\n    {{ tab.tabTitle }}\n  </li>\n</ul>\n<ng-content></ng-content>\n<div class=\"overlay\" [style.display]=\"isDisabled()\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/containers/tabs-container/tabs.container.html
// module id = 13
// module chunks = 0 1